import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../contexts/AuthContext';
import AuthModal from './AuthModal';

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: ${props => props.compact ? '8px 16px' : '10px 20px'};
  background: white;
  border: 1px solid #dadce0;
  border-radius: 24px;
  font-size: ${props => props.compact ? '14px' : '15px'};
  font-weight: 500;
  color: #3c4043;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);

  &:hover {
    background: #f8f9fa;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    transform: translateY(-1px);
  }

  &:active {
    background: #f1f3f4;
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: ${props => props.compact ? '18px' : '20px'};
    height: ${props => props.compact ? '18px' : '20px'};
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 16px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      fill="#4285F4"
    />
    <path
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      fill="#34A853"
    />
    <path
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      fill="#EA4335"
    />
  </svg>
);

/**
 * Login Button Component
 * Opens auth modal with email/password or Google OAuth options
 */
const LoginButton = ({ className, fullWidth = false, compact = false, children, defaultMode = 'login' }) => {
  const { loading } = useAuth();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        onClick={() => setShowModal(true)}
        disabled={loading}
        className={className}
        compact={compact}
        style={{ width: fullWidth ? '100%' : 'auto' }}
      >
        <GoogleIcon />
        <span>{children || 'Login'}</span>
      </Button>

      <AuthModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        defaultMode={defaultMode}
      />
    </>
  );
};

export default LoginButton;
